<div class="row">
    <div class="col-md-12">

    </div>
</div>
<div class="row mb-5">
    <div class="col-sm-6 ">
        <button type="button" class="btn btn-primary" (click)="open()"><i class="fa fa-plus"></i> {{ 'NEW_STORYBOARD' | translate }}</button>
        <a class="btn btn-default" (click)="logout()">Logout</a>
    </div>
    <div class="col-sm-6 text-right" *ngIf="folders.length || rootFolder.items.length">
        <button type="button" class="btn btn-default add-new-folder" (click)="newFolder()">
            <i class="fa fa-folder-o"></i> {{ 'ADD_NEW_FOLDER' | translate }}
        </button>
    </div>
</div>

<app-help *ngIf="checkFolderExists()"></app-help>

<div class="row" *ngIf="storyboardLoading">
    <div class="col-md-12">
        <div class="spinner-bar"></div>
    </div>
</div>

<div *ngIf="!checkFolderExists()">
    <div class="row" *ngIf="creatingFolder">
        <div class="col-sm-12">
            <app-create-folder (saveFolderEvent)="saveFolder($event)" (cancelCreateFolderEvent)="cancelCreateFolder($event)"></app-create-folder>
        </div>
    </div>
    <div
      class="row dropable-zone"
      dnd-droppable
      [allowDrop]="allowDropFunction(folder)"
      (onDropSuccess)="moveItem($event, folder)"
      [dropZones]="['folder']"
      *ngFor="let folder of folders; let i = index"
      [ngClass]="{'uncategorized-folder': isFolderForUncategorizedItems(folder), 'dropzone-hidden': uncategorizedFolderDropzoneHidden}">

        <div class="col-sm-12">
            <div class="row" *ngIf="!isFolderForUncategorizedItems(folder)">
                <div class="col-md-12">
                    <app-folder [folder]="folder" (deleteFolderEvent)="deleteFolder($event)"></app-folder>
                </div>
            </div>
            <div [ngbCollapse]="folder.collapsed && !isFolderForUncategorizedItems(folder)" *ngIf="folder.items.length || !uncategorizedFolderDropzoneHidden">
                <div class="row mb-3 mt-3 folder-items">
                    <div class="col-sm-6 col-md-4 col-xl-3" dnd-draggable (onDragStart)="showDropzoneForUncategorizedFolder()" (onDragEnd)="hideDropzoneForUncategorizedFolder()" [dropZones]="['folder']" [dragEnabled]="true" [dragData]="{'folder' : folder, 'item' : item}" *ngFor="let item of folder.items; let x = index">
                        <app-storyboard-item (duplicateStoryboardEvent)="duplicate($event)" (deleteStoryboardEvent)="delete($event)" [item]="item"></app-storyboard-item>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-list/storyboard-list.component.html